export default __webpack_public_path__ + "static/media/humidity.4650b536.svg";